import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useClassificationReviews({ documentKey }: { documentKey: string }) {
  return useSuspenseQuery({
    ...apiClient.getDocumentClassificationReviewDocumentsKeyClassificationReviewsGetOptions({
      path: {
        key: documentKey,
      },
    }),
  })
}
